import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { deleteEntity, getEntity } from './pharmacy-consumable-refund-bill-item.reducer';

export const PharmacyConsumableRefundBillItemDeleteDialog = () => {
  const dispatch = useAppDispatch();
  const pageLocation = useLocation();
  const navigate = useNavigate();
  const { id } = useParams<'id'>();

  const [loadModal, setLoadModal] = useState(false);

  useEffect(() => {
    dispatch(getEntity(id));
    setLoadModal(true);
  }, []);

  const pharmacyConsumableRefundBillItemEntity = useAppSelector(state => state.pharmacyConsumableRefundBillItem.entity);
  const updateSuccess = useAppSelector(state => state.pharmacyConsumableRefundBillItem.updateSuccess);

  const handleClose = () => {
    navigate(`/pharmacy-consumable-refund-bill-item${pageLocation.search}`);
  };

  useEffect(() => {
    if (updateSuccess && loadModal) {
      handleClose();
      setLoadModal(false);
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    dispatch(deleteEntity(pharmacyConsumableRefundBillItemEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="pharmacyConsumableRefundBillItemDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="tinyMedicRestApp.pharmacyConsumableRefundBillItem.delete.question">
        <Translate
          contentKey="tinyMedicRestApp.pharmacyConsumableRefundBillItem.delete.question"
          interpolate={{ id: pharmacyConsumableRefundBillItemEntity.id }}
        >
          Are you sure you want to delete this PharmacyConsumableRefundBillItem?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button
          id="tm-confirm-delete-pharmacyConsumableRefundBillItem"
          data-cy="entityConfirmDeleteButton"
          color="danger"
          onClick={confirmDelete}
        >
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PharmacyConsumableRefundBillItemDeleteDialog;
